/**
 * search filters
 */
$('#activitytypes_all').change(function(){
    let checked = $(this).prop('checked');
    if(checked){
        $('input[name="activitytypes[]"]').not(this).prop('checked', false);
        $(this).prop('checked', true);
    }else{
        $(this).prop('checked', true);
    }    
});

$('input[name="activitytypes[]"]').not('#activitytypes_all').change(function(){
    $('#activitytypes_all').prop('checked', false);
});

/**
 * Favorite toggles
 */
$('.js-activity_container').on('click','[data-action="toggle_favorite"]',function(e){
    let code = $(this).data('code');
    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        data: {
            _token: $('.js-activity_container').data('token'),
            
        },
        success: function(response){
            if(response.favorited){
                $('[data-action="toggle_favorite"][data-code="'+code+'"]').addClass('active');
            }else{
                $('[data-action="toggle_favorite"][data-code="'+code+'"]').removeClass('active');
            }
        }
    });    
});

$('.js-activity_wrapper [data-action="toggle_favorite"]').click(function(){
    let code = $(this).data('code');
    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        data: {
            _token: $('form[name="activity"] input[name="_token"]').val(),
        },
        success: function(response){
            if(response.favorited){
                $('[data-action="toggle_favorite"][data-code="'+code+'"]').addClass('active');
            }else{
                $('[data-action="toggle_favorite"][data-code="'+code+'"]').removeClass('active');
            }
        }
    });    
});